import $ from 'jquery';
import 'slick-carousel';


const heroOptions = {
   dots: true,
   infinite: true,
   mobileFirst: true,
   autoplay: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '<svg class="slick-arrow slick-arrow--prev"><use xlink:href="#chevron-left-light"></use></svg>',
   nextArrow: '<svg class="slick-arrow slick-arrow--next"><use xlink:href="#chevron-right-light"></use></svg>',
}

// Testimonials slider showing 3 

$('.jsTestimonialSlider').slick({
   slidesToShow: 3,
   slidesToScroll: 3,
   dots: true,
   prevArrow: '<svg class="slick-arrow slick-arrow--prev"><use xlink:href="#chevron-left-light"></use></svg>',
   nextArrow: '<svg class="slick-arrow slick-arrow--next"><use xlink:href="#chevron-right-light"></use></svg>',
   responsive: [{
      breakpoint: 990,
      settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
         infinite: true,
         dots: false
      }
   }],


});


$('.jsHeroSlider').each(function (index) {
   $(this).slick(heroOptions);
});

const catOptions = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '',
   nextArrow: '<svg><use xlink:href="#chevron-right-light"></use></svg>',
   responsive: [{
      breakpoint: 767,
      settings: {
         slidesToShow: 3,
         slidesToScroll: 1,
         infinite: true
      }
   },
   {
      breakpoint: 1200,
      settings: {
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true
      }
   }
   ]
}


$('.jsProdSlider').each(function (index) {
   $(this).slick(catOptions);
});



$('#mainImage').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   fade: true,
   prevArrow: '',
   nextArrow: '',
   asNavFor: '#imageNav'
});
$('#imageNav').slick({
   slidesToShow: 5,
   slidesToScroll: 1,
   asNavFor: '#mainImage',
   mobileFirst: true,
   arrows: false,
   dots: false,
   focusOnSelect: true,
   responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: true
         }
      }
   ]
});

const catOptionsGroup = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '',
   nextArrow: '<svg><use xlink:href="#chevron-right-light"></use></svg>',
   responsive: [{
      breakpoint: 767,
      settings: {
         slidesToShow: 2,
         slidesToScroll: 1,
         infinite: true
      }
   },
   {
      breakpoint: 1600,
      settings: {
         slidesToShow: 3,
         slidesToScroll: 1,
         infinite: true
      }
   }
   ]
}


$('.jsProdSliderGroup').each(function (index) {
   $(this).slick(catOptionsGroup);
});